import React, {Component} from 'react';
import './App.css';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import HeaderHtml from "../Header/HeaderHtml";
import Footer from "../Footer/Footer";
import ApiReference from "../ApiReference/ApiReference";
import Home from "../Home/Home";


export default class App extends Component {
    render() {
        return (
            <HashRouter>
                <HeaderHtml/>

                <Route path='/Home' component={Home}/>
                <Route path='/Api-reference' component={ApiReference}/>

                <Switch>
                    <Route path='/comp'/>
                    <Redirect to={'/Home'}/>
                </Switch>

                <Footer/>
            </HashRouter>
        );
    }
}
